"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DoraESNeo3_network;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoraESNeo3 = void 0;
const BSNeo3Helper_1 = require("../../helpers/BSNeo3Helper");
class DoraESNeo3 {
    constructor(network) {
        _DoraESNeo3_network.set(this, void 0);
        __classPrivateFieldSet(this, _DoraESNeo3_network, network, "f");
    }
    buildTransactionUrl(hash) {
        if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(__classPrivateFieldGet(this, _DoraESNeo3_network, "f")))
            throw new Error('DoraESNeo3 is only available on mainnet and testnet');
        return `https://dora.coz.io/transaction/neo3/${__classPrivateFieldGet(this, _DoraESNeo3_network, "f").id}/${hash}`;
    }
    buildContractUrl(contractHash) {
        if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(__classPrivateFieldGet(this, _DoraESNeo3_network, "f")))
            throw new Error('DoraESNeo3 is only available on mainnet and testnet');
        return `https://dora.coz.io/contract/neo3/${__classPrivateFieldGet(this, _DoraESNeo3_network, "f").id}/${contractHash}`;
    }
    buildNftUrl({ contractHash, tokenId }) {
        if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(__classPrivateFieldGet(this, _DoraESNeo3_network, "f")))
            throw new Error('DoraESNeo3 is only available on mainnet and testnet');
        return `https://dora.coz.io/nft/neo3/${__classPrivateFieldGet(this, _DoraESNeo3_network, "f").id}/${contractHash}/${tokenId}`;
    }
}
exports.DoraESNeo3 = DoraESNeo3;
_DoraESNeo3_network = new WeakMap();
